import { stringify } from 'qs';
import { createAPIService } from './api.service';
import { defaultAPIError } from './errors';

const service = createAPIService('/batch/api/');

export const ADMIN_BASE = 'admin/batches';
export const BATCH = (id = '', params = {}) =>
  `${ADMIN_BASE}/${id}?${stringify(params)}`;
export const TASKS = (id, params = {}) =>
  `${ADMIN_BASE}/${id}/tasks?${stringify(params)}`;
export const SCHEDULE = id => `${ADMIN_BASE}/${id}/schedule`;

// raw access to endpoints with no post-processing
export const createJob = async body => (await service.post(BATCH(), body)).data;

export const patchJob = async (id, body) =>
  (await service.patch(BATCH(id), body)).data;

export const patchTasks = async (id, { file, ...params }) => {
  const formData = new FormData();
  formData.append('file', file);
  return (
    await service.post(
      TASKS(id, { referenceType: 'UCI' }),
      file ? formData : params,
      {
        ...(file && { header: { 'Content-Type': 'multipart/form-data' } }),
      }
    )
  ).data;
};

export const scheduleJob = async (id, scheduledAt) =>
  (await service.post(SCHEDULE(id), { scheduledAt: scheduledAt })).data;

export const fetch = async id => (await service.get(BATCH(id))).data;

export const fetchJobs = async params =>
  (await service.get(BATCH(), { params })).data;

export const getTasks = async (id, params) =>
  (await service.get(TASKS(id), { params })).data;

export const deleteTasks = async (id, taskIds) =>
  (await service.delete(TASKS(id, { taskIds: taskIds.join(',') }))).data;

export const deleteJob = async id => (await service.delete(BATCH(id))).data;

// endpoints
service.create = async (...args) => {
  try {
    return await createJob(...args);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.patchJob = async (id, ...args) => {
  try {
    return await patchJob(id, ...args);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.fetchJobs = async params => {
  try {
    return await fetchJobs(params);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.fetchById = async id => {
  try {
    return await fetch(id);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.fetchTasks = async (id, params) => {
  try {
    return await getTasks(id, params);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.deleteJob = async id => {
  try {
    return await deleteJob(id);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.deleteTasks = async (jobId, taskIds) => {
  try {
    return await deleteTasks(jobId, taskIds);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.patchTasks = async (id, params, file) => {
  try {
    return await patchTasks(id, params, file);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

service.scheduleJob = async (id, when) => {
  try {
    return await scheduleJob(id, when);
  } catch (err) {
    throw defaultAPIError(err);
  }
};

export default service;
